
import { DefaultState } from 'store/types';
import { OccupancyInsightsTableFilters } from 'store/reducers/occupancy-insights/occupancyInsightsTableFilters/types';
import { ReservationOccupancyInsightsRow } from 'store/reducers/occupancy-insights/readReservationsOccupancyInsightsData/types';
import { RoomGuestReservationData } from 'types/rooms/room-guest';

export const READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_REQUEST = 'READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_REQUEST';
export const READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_SUCCESS = 'READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_SUCCESS';
export const READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_FAILURE = 'READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_FAILURE';

export interface ReservationOccupancyInsightsParams {
  filters: OccupancyInsightsTableFilters;
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
};

export interface ReservationsOccupancyInsightsLodgingOptionRoomGuest {
  name: string;
  gender: string;
}
export interface ReservationsOccupancyInsightsLodgingRequest {
  _id: string;
  fromDate: string;
  toDate: string;
  guest: ReservationsOccupancyInsightsLodgingOptionRoomGuest;
  status: string;
  isFlagged?: boolean;
  reservationData: RoomGuestReservationData;
}

export interface ReservationOccupancyInsightsEligibleReservationInsights {
  lodgingOption: {
    _id: string;
    name: string;
    address: string;
    lodgingType: string;
    lodgingOptionRooms: ReservationOccupancyInsightsRow[];
  }
}

export interface ReservationOccupancyInsightsData {
  rows: ReservationOccupancyInsightsEligibleReservationInsights[];
  totalCount: number;
};

export type ReadReservationOccupancyInsightsState = DefaultState & {
  contents?: ReservationOccupancyInsightsData;
};

interface ReadOccupancyInsightsDataRequest {
  type: typeof READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_REQUEST;
};

interface ReadOccupancyInsightsDataSuccess {
  type: typeof READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_SUCCESS,
  contents: ReservationOccupancyInsightsData;
}

interface ReadOccupancyInsightsDataFailure {
  type: typeof READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_FAILURE;
}

export type OccupancyInsightsActionTypes = ReadOccupancyInsightsDataRequest | ReadOccupancyInsightsDataSuccess | ReadOccupancyInsightsDataFailure;